import React, { useState, useEffect } from "react";
import "./BookingForm.css";

const BookingForm = ({
  formData = {},
  errors = {},
  handleInputChange = () => {},
  pickupLocation = "",
  dropoffLocation = "",
  fare = "",
  handleSubmit = () => {},
  suggestedVehicle = "",
}) => {
  const [localErrors, setLocalErrors] = useState(errors);
  const [touched, setTouched] = useState({});

  /* ---------------------------------------------------------------------- */
  /* 🔄 Sync backend errors (if any)                                        */
  /* ---------------------------------------------------------------------- */
  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      setLocalErrors((prev) => ({ ...prev, ...errors }));
    }
  }, [errors]);

  /* ---------------------------------------------------------------------- */
  /* 🧠 Validation logic                                                    */
  /* ---------------------------------------------------------------------- */
  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "name":
        if (!value.trim() || value.trim().length < 3)
          error = "Please enter your full name.";
        break;
      case "phone":
        if (!/^\+?\d{10,15}$/.test(value.trim()))
          error = "Enter a valid phone number (10–15 digits).";
        break;
      case "email":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()))
          error = "Enter a valid email address.";
        break;
      case "flight_number":
        if (value.trim() && !/^[A-Za-z]{2,3}\d{1,4}$/.test(value.trim()))
          error = "Enter a valid flight number (e.g. BA1234)";
        break;
      default:
        break;
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    handleInputChange(e);
    setLocalErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value),
    }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const isFormValid = () => {
    return (
      Object.values(localErrors).every((err) => !err) &&
      formData.name?.trim() &&
      formData.phone?.trim() &&
      formData.email?.trim()
    );
  };

  /* ---------------------------------------------------------------------- */
  /* ✈️ UI Rendering                                                        */
  /* ---------------------------------------------------------------------- */
  return (
    <div className="booking-form-container">
      <h3>🚕 Confirm Your Booking</h3>

      {/* Trip summary */}
      <div className="trip-summary">
        <p><strong>From:</strong> {pickupLocation}</p>
        <p><strong>To:</strong> {dropoffLocation}</p>
        <p><strong>Fare:</strong> £{fare}</p>
        {suggestedVehicle && (
          <p style={{ marginTop: "6px", fontStyle: "italic", color: "#444" }}>
            Vehicle: {suggestedVehicle}
          </p>
        )}
      </div>

      {/* Name */}
      <input
        type="text"
        name="name"
        placeholder="Full Name"
        value={formData.name}
        onChange={handleChange}
        onBlur={handleBlur}
        className={touched.name && localErrors.name ? "error" : touched.name ? "valid" : ""}
      />
      {touched.name && localErrors.name && <div className="error-text">{localErrors.name}</div>}

      {/* Phone */}
      <input
        type="text"
        name="phone"
        placeholder="Phone Number"
        value={formData.phone}
        onChange={handleChange}
        onBlur={handleBlur}
        className={touched.phone && localErrors.phone ? "error" : touched.phone ? "valid" : ""}
      />
      {touched.phone && localErrors.phone && <div className="error-text">{localErrors.phone}</div>}

      {/* Email */}
      <input
        type="email"
        name="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        onBlur={handleBlur}
        className={touched.email && localErrors.email ? "error" : touched.email ? "valid" : ""}
      />
      {(touched.email && localErrors.email) || errors.email ? (
        <div className="error-text">{localErrors.email || errors.email}</div>
      ) : null}

      {/* Flight number */}
      <input
        type="text"
        name="flight_number"
        placeholder="Flight Number (optional, e.g. BA1234)"
        value={formData.flight_number}
        onChange={handleChange}
        onBlur={handleBlur}
        className={
          touched.flight_number && localErrors.flight_number ? "error" : touched.flight_number ? "valid" : ""
        }
      />
      {touched.flight_number && localErrors.flight_number && (
        <div className="error-text">{localErrors.flight_number}</div>
      )}

      {/* Notes */}
      <textarea
        name="notes"
        placeholder="Additional Notes (optional)"
        value={formData.notes}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      {/* General backend error */}
      {errors.form && (
        <div className="error-text" style={{ textAlign: "center", marginTop: "10px" }}>
          {errors.form}
        </div>
      )}

      {/* Submit */}



<button
  onClick={(e) => {
    e.preventDefault();
    if (isFormValid()) handleSubmit(e);
  }}
  disabled={!isFormValid()}
  className={!isFormValid() ? "disabled-btn" : ""}
>
  ✅ Confirm & Proceed to Payment
</button>







    </div>
  );
};

export default BookingForm;

